// html-cell-renderer.component.ts
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { decodeHtmlText } from 'src/app/core/utils/util-master';

@Component({
  selector: 'map-html-cell-renderer',
  template: `<div [innerHTML]="decodedValue"></div>`,
})
export class HtmlCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  decodedValue: string;

  agInit(params: any): void {
    this.params = params;
    this.decodedValue = decodeHtmlText(params.value);
  }

  refresh(params: any): boolean {
    this.params = params;
    this.decodedValue = decodeHtmlText(params.value);
    return true;
  }
}
